import { LOCATION_CHANGE } from 'connected-react-router';
import { removeAttributeFromObject } from '../../../util/GeneralUtil';
import { isMultiSelectFilter, isRangeFilter, isBucketFilter, isLinkFilter } from '@as-react/common-utils';
import { FilterActionTypes } from '../../../enums/ActionEnums';
export const initialState = {};
const mapSetFilterObjectToFilteredItemWithFilterType = (setFilterObject) => {
    let data = {
        filterType: setFilterObject.filterType,
        filterOnName: setFilterObject.filterOnName,
        filterContentType: setFilterObject.filterContentType,
        queryParamKey: setFilterObject.queryParamKey,
    };
    if (isMultiSelectFilter(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { values: setFilterObject.filteredItems.map(filterItem => ({
                filterType: setFilterObject.filterType,
                filterOnName: setFilterObject.filterOnName,
                filterOn: setFilterObject.filterOn,
                filterKey: filterItem.filterKey,
                filterKeyName: filterItem.filterKeyName,
            })) });
    }
    else if (isRangeFilter(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { rangeMin: Number(setFilterObject.filteredItems[0].filterKey), rangeMax: Number(setFilterObject.filteredItems[1].filterKey), filterPrefix: setFilterObject.filterPrefix, filterSuffix: setFilterObject.filterSuffix });
    }
    else if (isBucketFilter(setFilterObject) || isLinkFilter(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { values: [...[setFilterObject.filteredItems[setFilterObject.filteredItems.length - 1]]] });
    }
    return data;
};
const updateActiveFilters = (state = initialState, action) => {
    const newFilteredItemWithFilterType = mapSetFilterObjectToFilteredItemWithFilterType(action.payload);
    return Object.assign(Object.assign({}, state.activeFilters), {
        [action.payload.filterOn]: Object.assign({}, newFilteredItemWithFilterType),
    });
};
const removeFilterOnFromActiveFilters = (state = initialState, action) => {
    let newActiveFilters;
    if (state.activeFilters && state.activeFilters[action.payload.filterOn]) {
        newActiveFilters = removeAttributeFromObject(state.activeFilters, action.payload.filterOn);
        if (Object.keys(newActiveFilters).length === 0) {
            newActiveFilters = null;
        }
    }
    else {
        newActiveFilters = Object.assign({}, state.activeFilters);
    }
    return newActiveFilters;
};
export const loadFilterReducer = (initialData = {}) => {
    const initialReducerState = Object.assign(Object.assign({}, initialState), initialData);
    return (state = initialReducerState, action) => {
        switch (action.type) {
            case LOCATION_CHANGE:
                return action.payload.location && action.payload.location.state
                    ? Object.assign({}, action.payload.location.state.filters) : state;
            case FilterActionTypes.SET_FILTERS:
                return Object.assign(Object.assign({}, state), { activeFilters: updateActiveFilters(state, action) });
            case FilterActionTypes.REMOVE_FILTER:
                return Object.assign(Object.assign({}, state), { activeFilters: removeFilterOnFromActiveFilters(state, action) });
            case FilterActionTypes.REMOVE_ALL_FILTERS:
                return Object.assign(Object.assign({}, state), { activeFilters: null });
            case FilterActionTypes.SET_ACTIVE_FILTERS:
                return Object.assign(Object.assign({}, state), { activeFilters: action.payload });
            default:
                return state;
        }
    };
};
export const filterReducer = loadFilterReducer();
